/// <amd-module name="Agile/Sprints/Directory/Redux/SprintDirectoryReducer" />
import { ISprintDirectoryState, ISprintsDirectoryDataProviderData } from "Agile/Sprints/Directory/SprintDirectoryContracts";
import { default as produce } from "immer";
import { DirectoryActions, DirectoryActionTypes } from "Agile/Directory/Redux/DirectoryActions";
import { SprintDirectoryActionTypes, SprintDirectoryActions } from "./SprintDirectoryActions";

export function sprintDirectoryReducer(state: ISprintDirectoryState, action: DirectoryActions | SprintDirectoryActions): ISprintDirectoryState {
    state = state || getDefaultState();

    return produce(state, draft => {
        switch (action.type) {
            case DirectoryActionTypes.LoadAllDataSucceeded: {
                const payload: ISprintsDirectoryDataProviderData = action.payload as ISprintsDirectoryDataProviderData;
                if (payload.allTeams && payload.pageSize) {
                    draft.allTeams = payload.allTeams;
                    draft.pageSize = payload.pageSize;
                }

                break;
            }

            case SprintDirectoryActionTypes.NewSprintOpened: {
                draft.isSprintPaneOpen = true;
                draft.editSprintInformation = undefined;

                break;
            }

            case SprintDirectoryActionTypes.EditSprintOpened: {
                draft.isSprintPaneOpen = true;
                draft.editSprintInformation = action.payload;

                break;
            }

            case SprintDirectoryActionTypes.NewSprintSucceeded: {
                draft.isSprintPaneOpen = false;
                break;
            }

            case SprintDirectoryActionTypes.EditSprintSucceeded: {
                draft.isSprintPaneOpen = false;
                draft.editSprintInformation = undefined;
                break;
            }

            case SprintDirectoryActionTypes.SprintPaneClosed: {
                draft.isSprintPaneOpen = false;
                draft.editSprintInformation = undefined;

                break;
            }
        }
    });
}

export function getDefaultState(): ISprintDirectoryState {
    return {
        isSprintPaneOpen: false
    };
}
